<template>
  <div>
    <div class="statistics">
      <div class="statistics-left">
        <CardContainer style="height: 100%;">
          <div class="title">版本总数(版)</div>
          <div class="total">{{ versionTotal }}</div>
          <hl-button class="history-btn" type="text" @click="handleHistory">
            版本历史<i class="el-icon-arrow-right" style="font-size: 14px;"></i>
          </hl-button>
          <div class="img"></div>
        </CardContainer>
      </div>
      <div class="statistics-right">
        <CardContainer style="height: 100%;">
          <div class="left-div new">
            <div class="total">{{ newVersion | format }}</div>
            <div class="time">{{ getTime(newVersionTime) }}</div>
            <div class="name">最新版本</div>
          </div>
          <div class="left-div old">
            <div class="total">{{ oldVersion | format }}</div>
            <div class="number">{{ oldNumber }}台</div>
            <div class="name">最老版本</div>
          </div>
          <div class="fota-query">
            <div class="total">{{ moreVersion | format }}</div>
            <div class="number">{{ moreNumber }}台</div>
            <div class="name">设备最多版本</div>
            <el-progress
              type="circle"
              :width="84"
              :stroke-width="10"
              :percentage="25"
              color="#00CBD3"
            ></el-progress>
          </div>
        </CardContainer>
      </div>
    </div>
    <CardContainer class="table-div">
      <div style="display: grid; grid-template-columns: 1fr auto;">
        <span v-if="addRole">
          <hl-button @click="handleAdd">
            新增
          </hl-button>
        </span>
        <CommonForm @search="formSearch" :form-json="formjson" />
      </div>
      <CommonTable
        ref="table"
        :data="tableData"
        :total="total"
        @change="handleTableChange"
        :operation="operation"
        @operation="handleOperation"
        :table-json="tablejson"
        :hadCalculatedOptWidthFlag="true"
        :operationColWidthNumber="160"
      >
      </CommonTable>
    </CardContainer>
    <Dialog :row="row" @refresh="formSearch" v-if="showModel" :showModel.sync="showModel" />
  </div>
</template>

<script>
import { formatTime, format } from '@/utils/utils'
import formjson from './Model/FirmwareFormjson.Index'
import tablejson from './Model/FirmwareTablejson.Index'
import formTableMixin from '@/mixins/formTableMixin'
import getRoleFromPath from '@/mixins/getRoleFromPath'
import { getRoleByOperationCode } from '@/authorized'
import Dialog from './Dialog'
export default {
  mixins: [formTableMixin, getRoleFromPath],
  props: {
    firmwareRole: {
      type: Array
    }
  },
  filters: {
    format
  },
  components: {
    Dialog
  },
  data() {
    return {
      versionTotal: 0,
      newVersion: '',
      newVersionTime: '2021-01-01',
      oldVersion: '',
      oldNumber: 0,
      moreVersion: '',
      moreNumber: 0,
      tablejson,
      formjson,
      operation: [
        {
          name: '编辑',
          type: 'edit',
          hide: (row) => {
            return !this.updateRole || row.status !== 'DISABLED'
          }
        },
        {
          name: '启用',
          type: 'open',
          hide: (row) => {
            return !this.openStopRole || row.status !== 'DISABLED'
          }
        },
        {
          name: '禁用',
          type: 'stop',
          hide: (row) => {
            return !this.openStopRole || row.status !== 'ENABLE'
          }
        },
        {
          name: '删除',
          type: 'delete',
          hide: (row) => {
            return !this.deleteRole || row.status !== 'DISABLED'
          }
        }
      ],
      showModel: false,
      row: {},
      queryApi: this.$api.fota.firmware_version_page
    }
  },
  computed: {
    /********* 权限 ***********/
    // this.firmwareRole 计算属性通过mixins: [getRoleFromPath] 注入
    // 导出权限
    // 新建
    addRole() {
      let val = getRoleByOperationCode(this.firmwareRole, 'add')
      return val ? val.isPermission == 'Y' : false
    },
    // 编辑
    updateRole() {
      let val = getRoleByOperationCode(this.firmwareRole, 'update')
      return val ? val.isPermission == 'Y' : false
    },
    // 删除
    deleteRole() {
      let val = getRoleByOperationCode(this.firmwareRole, 'del')
      return val ? val.isPermission == 'Y' : false
    },
    // 启停用
    openStopRole() {
      let val = getRoleByOperationCode(this.firmwareRole, 'open_stop')
      return val ? val.isPermission == 'Y' : false
    }
    /********* 权限 ***********/
  },
  methods: {
    formSearch(data) {
      if (!data) {
        data = this.cacheData
      }
      data.firmwareType = 'LOWER'
      this.search(data, null, this.queryApi)
    },
    handleHistory() {
      this.$router.push('/fota/lower/history')
    },
    handleAdd() {
      this.row = {}
      this.showModel = true
    },
    handleEdit(row) {
      this.row = row
      this.showModel = true
    },
    handleOpen(row) {
      this.$confirm('确认启用该固件?', '提示', {
        confirmButtonText: '启用',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.fota.firmware_version_enable, params)
            .then(() => {
              this.$message.success('固件已启用')
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleStop(row) {
      this.$confirm('确认禁用该固件?', '提示', {
        confirmButtonText: '禁用',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.fota.firmware_version_disable, params)
            .then(() => {
              this.$message.success('固件已禁用')
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    handleDelete(row) {
      this.$confirm('确认删除该固件?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {
            id: row.id
          }
          this.$ajax
            .post(this.$api.fota.firmware_version_remove, params)
            .then(() => {
              this.$message.success('固件已删除')
              this.formSearch()
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    getTime(val) {
      return formatTime(val, 'YYYY-MM-DD')
    },
    handleOperation(data) {
      const { type, row } = data
      switch (type) {
        case 'edit':
          this.handleEdit(row)
          break
        case 'open':
          this.handleOpen(row)
          break
        case 'stop':
          this.handleStop(row)
          break
        case 'delete':
          this.handleDelete(row)
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics {
  display: flex;
  .statistics-left {
    position: relative;
    flex: 1;
    height: 194px;
    .title {
      line-height: 24px;
      font-size: 16px;
      color: #666666;
    }
    .total {
      line-height: 56px;
      font-family: Barlow-SemiBold;
      font-size: 48px;
      font-weight: 600;
      color: #333333;
    }
    .history-btn {
      position: absolute;
      left: 24px;
      bottom: 24px;
    }
    .img {
      position: absolute;
      right: 24px;
      bottom: 24px;
      width: 48px;
      height: 48px;
      background-image: url('../../../assets/edition.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }
  .statistics-right {
    flex: 3;
    height: 194px;
    margin-left: 24px;
    /deep/ .el-card__body {
      display: flex;
      .left-div {
        position: relative;
        flex: 2;
        margin-left: 24px;
        padding: 24px;
        height: 146px;
        background-repeat: no-repeat;
        background-position: left center;
        background-size: cover;
        border-radius: 15px;
        &:first-child {
          margin-left: 0;
        }
        &.new {
          background-image: url('../../../assets/device_added_bg.jpg');
        }
        &.old {
          background-image: url('../../../assets/fota_fail_times_bg.jpg');
        }
        .total {
          line-height: 32px;
          font-family: Barlow-SemiBold;
          font-size: 24px;
          font-weight: 600;
          color: #ffffff;
        }
        .time {
          margin-top: 8px;
          padding: 0 8px;
          width: max-content;
          line-height: 22px;
          font-size: 14px;
          font-weight: 600;
          color: #2e85f7;
          background-image: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.89) 100%);
          border-radius: 9.5px;
        }
        .number {
          margin-top: 8px;
          padding: 0 8px;
          width: max-content;
          line-height: 22px;
          font-size: 14px;
          font-weight: 600;
          color: #cc5353;
          background-image: linear-gradient(180deg, #ffffff 0%, rgba(255, 255, 255, 0.89) 100%);
          border-radius: 9.5px;
        }
        .name {
          position: absolute;
          left: 24px;
          bottom: 24px;
          line-height: 22px;
          font-size: 14px;
          color: #ffffff;
        }
      }
      .fota-query {
        position: relative;
        flex: 3;
        padding: 24px;
        margin-left: 24px;
        height: 146px;
        background-image: url('../../../assets/normal_bg.jpg');
        background-repeat: no-repeat;
        background-position: left center;
        background-size: cover;
        border-radius: 15px;
        .total {
          line-height: 32px;
          font-family: Barlow-SemiBold;
          font-size: 24px;
          font-weight: 600;
          color: #333333;
        }
        .number {
          margin-top: 8px;
          padding: 0 8px;
          width: max-content;
          line-height: 22px;
          font-size: 14px;
          font-weight: 600;
          color: #ffffff;
          background: #00cbd3;
          border-radius: 9.5px;
        }
        .name {
          position: absolute;
          left: 24px;
          bottom: 24px;
          line-height: 22px;
          font-size: 14px;
          color: #666666;
        }
        .el-progress {
          position: absolute;
          top: 50%;
          right: 24px;
          margin-top: -42px;
          path:first-child {
            stroke: #d4eef0;
          }
          .el-progress__text {
            line-height: 24px;
            font-size: 16px !important;
            font-weight: 600;
            color: #333333;
          }
        }
      }
    }
  }
}
.table-div {
  margin-top: 24px;
}
</style>
